import * as React from 'react';
import {
  Container,
  Grid,
  Header,
  Responsive
} from 'semantic-ui-react';
import { getI18n } from 'services/i18n-service';
import { translations } from 'types/translations';
import ConnectionStatus from 'components/connection-status';
import * as config from 'config';

import './styles.css';

const CONNECTION_STATUS_DELAY = 5000;

// tslint:disable-next-line:no-any
export const LandingTemplate: React.StatelessComponent<{}> = (props) => {
  const i18n = getI18n();

  const copyrights = (
    <>
      &copy; {i18n.t(translations.OptelGroup)} {(new Date()).getFullYear()} -&nbsp;
      <span className="slim-text">{i18n.t(translations.AllRightsReserved)}</span>
    </>
  );

  const aboutOptel = (
    <span>
      <a href="https://www.optelgroup.com/" target="_blank" className="landing-template-link">
        {i18n.t(translations.AboutOptel)}
      </a>
    </span>
  );

  const optelTerms = (
    <span>
      <a href="https://www.optelgroup.com/privacy-policy/" target="_blank" className="landing-template-link">
        {i18n.t(translations.TermsAndConditions)}
      </a>
    </span>
  );

  const version = (
    <span className="slim-text">
      {config.APPLICATION_VERSION}
    </span>
  );

  return (
    <>
      <Container fluid={true} className="landing-main-content">
        <Header className="landing-title main-logo" ><span className="slim-text" >OPTEL</span>&nbsp;Product Explorer&trade;</Header>
        <Grid container={true} stackable={true} verticalAlign="middle"
          padded="vertically" inverted={true} className="landing-content">
          <Grid.Row>
            <Grid.Column width={10} className="no-top-padding">
              <Header as="h1" className="landing-slogan" inverted={true} >
                {i18n.t(translations.LandingPageSloganPart1)}
              </Header>
            </Grid.Column>
            <Grid.Column width={6} className="landing-page-children">
              {props.children}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
      <Responsive {...Responsive.onlyMobile}>
        <div className="landing-terms">
          <Header inverted={true}>
          {aboutOptel}
          {optelTerms}
          <p>
            {copyrights}
          </p>
        </Header>
        </div>
        <div className="landing-connection-status no-margin-bottom segment-version">
          <ConnectionStatus
            shouldDisplay={true}
            delay={CONNECTION_STATUS_DELAY}
          />
          <span>
            {config.APPLICATION_VERSION}
          </span>
        </div>
      </Responsive>
      <Responsive minWidth={Responsive.onlyTablet.minWidth} className="landing-terms">
        <Header inverted={true}>
          <p>
            {copyrights}
            {aboutOptel}
            {optelTerms}
            {version}
            <span>
              <ConnectionStatus
                shouldDisplay={true}
                delay={CONNECTION_STATUS_DELAY}
              />
            </span>
          </p>
        </Header>
      </Responsive>
    </>
  );
};


// WEBPACK FOOTER //
// ./src/components/landing-template/component.tsx